import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './Header';
import Home from './Home';
import Menu from './Menu';
import Footer from './Footer';
import SystemAlerts from "./SystemAlerts";
import Register from './Register';
import ChangePassword from './ChangePassword';
import Login from './Login';
import PatLogin from './PatLogin';
//Front Office
import FrontMenu from './FrontOffice/FrontMenu';
import CashMenu from './FrontOffice/CashMenu';
import FoLabEntry from './FrontOffice/FoLabEntry';
import CashOp from './FrontOffice/CashOp';
import CashLab from './FrontOffice/CashLab';
import LabEntry from './FrontOffice/LabEntry';
import FoInvEntry from './FrontOffice/FoInvEntry';
import InvEntry from './FrontOffice/InvEntry';
import CashInv from './FrontOffice/CashInv';
import CashPack from './FrontOffice/CashPack';
import FoMinEntry from './FrontOffice/FoMinEntry';
import CashMin from './FrontOffice/CashMin';
import MinEntry from './FrontOffice/MinEntry';
import OpDashboard from './FrontOffice/OpDashboard';
import OpVitals from './FrontOffice/OpVitals';
import VitalsView from './FrontOffice/VitalsView';
import FoIpLabEntry from './FrontOffice/FoIpLabEntry';
import FoIpInvEntry from './FrontOffice/FoIpInvEntry';
import IpLabEntry from './FrontOffice/IpLabEntry';
import IpInvEntry from './FrontOffice/IpInvEntry';
import CashIp from './FrontOffice/CashIp';
//Lab
import LabMenu from './Lab/LabMenu';
import LabView from './Lab/LabView';
import LabMachine from './Lab/LabMachine';
import CreateWO from './Lab/CreateWO';
import CreateSampleid from './Lab/CreateSampleid';
import OrderAccept from './Lab/OrderAccept';
import SampleCollect from './Lab/SampleCollect';
import LabResultEntry from './Lab/LabResultEntry';
import LabResultEntrySaved from './Lab/LabResultEntrySaved';
import LabResultView from './Lab/LabResultView';
import LabReportOp from './Lab/LabReportOp';
import LabReportOpAll from './Lab/LabReportOpAll';
import CollectionLab from './Lab/CollectionLab';
import LabPayment from './Lab/LabPayment';
import LabInvoiceOp from './Lab/LabInvoiceOp';
import AddCat from './Lab/AddCat';
import EditCat from './Lab/EditCat';
import AddSubCat from './Lab/AddSubCat';
import EditSubCat from './Lab/EditSubCat';
import AddTest from './Lab/AddTest';
import ViewTest from './Lab/ViewTest';
import EditTest from './Lab/EditTest';
import IpLabPayment from './Lab/IpLabPayment';
import LabInvoiceIp from './Lab/LabInvoiceIp';
import IpLabResultEntry from './Lab/IpLabResultEntry';
import IpLabResultEntrySaved from './Lab/IpLabResultEntrySaved';
import LabReportIp from './Lab/LabReportIp';
import LabReportIpAll from './Lab/LabReportIpAll';
import LabAllResultView from './Lab/LabAllResultView';
//Radiology
import AddRadio from './Radiology/AddRadio';
import EditRadio from './Radiology/EditRadio';
import InvMenu from './Radiology/InvMenu';
import InvView from './Radiology/InvView';
import InvResultEntry from './Radiology/InvResultEntry';
import InvResultView from './Radiology/InvResultView';
import InvFilesView from './Radiology/InvFilesView';
import CollectionInv from './Radiology/CollectionInv';
import InvPayment from './Radiology/InvPayment';
import InvInvoiceOp from './Radiology/InvInvoiceOp';
import IpInvPayment from './Radiology/IpInvPayment';
import InvInvoiceIp from './Radiology/InvInvoiceIp';
import DicomStart from './Radiology/DicomStart';
import DICOMViewer from './Radiology/DICOMViewer';
//Minor
import AddMinCat from './Minor/AddMinCat';
import EditMinCat from './Minor/EditMinCat';
import AddMinComp from './Minor/AddMinComp';
import EditMinComp from './Minor/EditMinComp';
import CollectionMin from './Minor/CollectionMin';
import MinPayment from './Minor/MinPayment';
import MinInvoiceOp from './Minor/MinInvoiceOp';
import MinView from './Minor/MinView';
//Patient
import PatientRegister from './Patient/PatientRegister';
import PatSearch from './Patient/PatSearch';
import EmrDetails from './Patient/EmrDetails';
import PatBillSearch from './Patient/PatBillSearch';
import PatBillDetails from './Patient/PatBillDetails';
import PatRegisterSearch from './Patient/PatRegisterSearch';
import EditPatient from './Patient/EditPatient';
import PatPrint from './Patient/PatPrint';
import IpPatPrint from './Patient/IpPatPrint';
import PatMenu from './Patient/PatMenu';
import PatEmrDetails from './Patient/PatEmrDetails';
import BillDetailsPat from './Patient/BillDetailsPat';
import PatLabDetails from './Patient/PatLabDetails';
import PatVitalDetails from './Patient/PatVitalDetails';
import PatDrugDetails from './Patient/PatDrugDetails';
import PatLabReportIpAll from './Patient/PatLabReportIpAll';
import PatLabReportOpAll from './Patient/PatLabReportOpAll';
import PatOpCaseSheet from './Patient/PatOpCaseSheet';
import PatDischargeSummary from './Patient/PatDischargeSummary';
import PatIpBillSummary from './Patient/PatIpBillSummary';
import PatDrugPres from './Patient/PatDrugPres';

//Consultant
import AddConsultant from './Consultant/AddConsultant';
import EditConsultant from './Consultant/EditConsultant';
import ConsultMenu from './Consultant/ConsultMenu';
import AddRefConsultant from './Consultant/AddRefConsultant';
import AddConsDept from './Consultant/AddConsDept';
import ConsView from './Consultant/ConsView';
import ConsDetail from './Consultant/ConsDetail';
import OpCaseSheet from './Consultant/OpCaseSheet';
import IpViewList from './Consultant/IpViewList';
import IpConsDetail from './Consultant/IpConsDetail';
import ConsSearch from './Consultant/ConsSearch';
import ConsPayment from './Consultant/ConsPayment';
import ConsPayReport from './Consultant/ConsPayReport';
//Cashier
import RefundReport from './Opbill/RefundReport';
import RefundEntry from './Opbill/RefundEntry';
import RefundDetails from './Opbill/RefundDetails';
import CancelEntry from './Opbill/CancelEntry';
import CancelBill from './Opbill/CancelBill';
import RefundInvoiceOp from './Opbill/RefundInvoiceOp';
import DueEntry from './Opbill/DueEntry';
import DueDetails from './Opbill/DueDetails';
import DueInvoiceOp from './Opbill/DueInvoiceOp';
import DueReport from './Opbill/DueReport';
import PaymentDetail from './Opbill/PaymentDetail';
import CollectionAll from './Opbill/CollectionAll';
import CollectionCredit from './Opbill/CollectionCredit';
import PendingBills from './Opbill/PendingBills';
import DiscountReport from './Opbill/DiscountReport';
import AddExpense from './Opbill/AddExpense';
import ExpenseReport from './Opbill/ExpenseReport';
//Appointment
import OpDoc from './Opbill/OpDoc';
import OpDep from './Opbill/OpDep';
import FixAppointment from './Opbill/FixAppointment';
import OpToken from './Opbill/OpToken';
import CollectionOp from './Opbill/CollectionOp';
import OpPayment from './Opbill/OpPayment';
import OpInvoice from './Opbill/OpInvoice';
import OpView from './Opbill/OpView';
//Other
import SpeechPre from './Other/SpeechPre';
import MasterMenu from './Other/MasterMenu';
import ComposeMessage from './Other/ComposeMessage';
import News from './Other/News';
import AddDept from './Other/AddDept';
import AddDesignation from './Other/AddDesignation';
import GenerateBarcode from './Other/GenerateBarcode';
import Support from './Other/Support';
import AddTemplate from './Other/AddTemplate';
import EditTemplate from './Other/EditTemplate';
import MisMenu from './Other/MisMenu';
import MisCollection from './Other/MisCollection';

//Ip
import IpMenu from './IpBill/IpMenu';
import IpAdmit from './IpBill/IpAdmit';
import IpPatientRegister from './IpBill/IpPatientRegister';
import IpPatientRegisterNew from './IpBill/IpPatientRegisterNew';
import ConfirmIpAdmit from './IpBill/ConfirmIpAdmit';
import IpList from './IpBill/IpList';
import IpWaitingList from './IpBill/IpWaitingList';
import IpPatView from './IpBill/IpPatView';
import IpAdvance from './IpBill/IpAdvance';
import IpPayment from './IpBill/IpPayment';
import IpInvoice from './IpBill/IpInvoice';
import RefundInvoiceIp from './IpBill/RefundInvoiceIp';
import WardChange from './IpBill/WardChange';
import IpBillList from './IpBill/IpBillList';
import IpBillProv from './IpBill/IpBillProv';
import IpBillSummary from './IpBill/IpBillSummary';
import IpBillIns from './IpBill/IpBillIns';
import DischargeDate from './IpBill/DischargeDate';
import DischargeNotes from './IpBill/DischargeNotes';
import EditDischarge from './IpBill/EditDischarge';
import IpDischargeSummary from './IpBill/IpDischargeSummary';
import PreAuthList from './IpBill/PreAuthList';
import PaymentDetailIp from './IpBill/PaymentDetailIp';
import AdmitDate from './IpBill/AdmitDate';
import IpRefundReport from './IpBill/IpRefundReport';
//OT
import OtMenu from './IpBill/OT/OtMenu';
import SurgeryType from './IpBill/OT/SurgeryType';
import EditSurgeryType from './IpBill/OT/EditSurgeryType';
import OtEntry from './IpBill/OT/OtEntry';
import OtRequest from './IpBill/OT/OtRequest';
import OtList from './IpBill/OT/OtList';
import OtUpdate from './IpBill/OT/OtUpdate';
import OtNotesList from './IpBill/OT/OtNotesList';
import OtNotes from './IpBill/OT/OtNotes';
import OtReport from './IpBill/OT/OtReport';
//Nurse
import NurseMenu from './IpBill/Nurse/NurseMenu';
import NurseViewList from './IpBill/Nurse/NurseViewList';
import NursePatView from './IpBill/Nurse/NursePatView';
import NurseNotes from './IpBill/Nurse/NurseNotes';
import VitalSign from './IpBill/Nurse/VitalSign';
import DietDetail from './IpBill/Nurse/DietDetail';
import ConsultNotes from './IpBill/Nurse/ConsultNotes';
import ComaScale from './IpBill/Nurse/ComaScale';
import Insulin from './IpBill/Nurse/Insulin';
import Respirate from './IpBill/Nurse/Respirate';
import ChestPhysio from './IpBill/Nurse/ChestPhysio';
import Fluid from './IpBill/Nurse/Fluid';
import Positioning from './IpBill/Nurse/Positioning';
import Pupils from './IpBill/Nurse/Pupils';
import IpDrugEntry from './IpBill/Nurse/IpDrugEntry';
import IpDrugUse from './IpBill/Nurse/IpDrugUse';
//Insurance
import AddInsurType from './IpBill/Insurance/AddInsurType';
import AddInsurCmpy from './IpBill/Insurance/AddInsurCmpy';
import EditInsurCmpy from './IpBill/Insurance/EditInsurCmpy';
import InsuranceReport from './IpBill/Insurance/InsuranceReport';
//Rooms
import AddRoom from './IpBill/Rooms/AddRoom';
import AddRoomNo from './IpBill/Rooms/AddRoomNo';
import EditRoomNo from './IpBill/Rooms/EditRoomNo';
import ViewRoom from './IpBill/Rooms/ViewRoom';
//Accounting
import AccountMenu from './Accounting/AccountMenu';
import AddBank from './Accounting/AddBank';
import AddDeposit from './Accounting/AddDeposit';
import AddCheque from './Accounting/AddCheque';
import AccountReport from './Accounting/AccountReport';
//Hrms
import HrmsMenu from './Hrms/HrmsMenu';
import AddEmployee from './Hrms/AddEmployee';
import EmpList from './Hrms/EmpList';
import EditEmployee from './Hrms/EditEmployee';
import ViewEmployee from './Hrms/ViewEmployee';
import GeneratePayslip from './Hrms/GeneratePayslip';
import SalaryList from './Hrms/SalaryList';
import ViewPayslip from './Hrms/ViewPayslip';
import Shift from './Hrms/Shift';
import EditShift from './Hrms/EditShift';
import EmpRooster from './Hrms/EmpRooster';
import LeaveApplication from './Hrms/LeaveApplication';

//Pharmacy
import PharmMenu from './Pharmacy/PharmMenu';
import PharmStore from './Pharmacy/PharmStore';
import DrugView from './Pharmacy/DrugView';
import DrugPayOther from './Pharmacy/DrugPayOther';
import DrugPaySaved from './Pharmacy/DrugPaySaved';
import PharmInvoiceOther from './Pharmacy/PharmInvoiceOther';
import PharmInvoiceIndent from './Pharmacy/PharmInvoiceIndent';
import SalesReturn from './Pharmacy/SalesReturn';
import PharmInvoiceReturn from './Pharmacy/PharmInvoiceReturn';
import DrugPayDr from './Pharmacy/DrugPayDr';
import RaiseIndent from './Pharmacy/RaiseIndent';
import DrugPayIndent from './Pharmacy/DrugPayIndent';
import GrnEntry from './Pharmacy/GrnEntry';
import GrnList from './Pharmacy/GrnList';
import GrnInvoice from './Pharmacy/GrnInvoice';
import PoList from './Pharmacy/PoList';
import PoInvoice from './Pharmacy/PoInvoice';
import InternalReturn from './Pharmacy/InternalReturn';
import PurchaseReturn from './Pharmacy/PurchaseReturn';
import PurchaseInvoiceReturn from './Pharmacy/PurchaseInvoiceReturn';
import OtDrugList from './Pharmacy/OtDrugList';
import DrugPayOt from './Pharmacy/DrugPayOt';
import DrugPayIp from './Pharmacy/DrugPayIp';
import DrugIpPay from './Pharmacy/DrugIpPay';
import VendorSearch from './Pharmacy/VendorSearch';
import VendorPayment from './Pharmacy/VendorPayment';
import AddDrugGeneric from './Pharmacy/AddDrugGeneric';
//Pharmacy Masters
import AddManufacturer from './Pharmacy/AddManufacturer';
import EditManufacturer from './Pharmacy/EditManufacturer';
import AddDistributor from './Pharmacy/AddDistributor';
import EditDistributor from './Pharmacy/EditDistributor';
import DrugList from './Pharmacy/DrugList';
import ExpiryList from './Pharmacy/ExpiryList';
import IndentExpiryList from './Pharmacy/IndentExpiryList';
import IndentDrugList from './Pharmacy/IndentDrugList';
import EditDrug from './Pharmacy/EditDrug';
import EditGeneric from './Pharmacy/EditGeneric';
import EditIndentDrug from './Pharmacy/EditIndentDrug';
import AddNewProduct from './Pharmacy/AddNewProduct';
//Phamrcy Reports
import PharmCollectionAll from './Pharmacy/PharmCollectionAll';
import SaleReturnReport from './Pharmacy/SaleReturnReport';
import PharmDetail from './Pharmacy/PharmDetail';
import SalesGstReport from './Pharmacy/SalesGstReport';
import DetailSalesGstReport from './Pharmacy/DetailSalesGstReport';
import SalesGstStat from './Pharmacy/SalesGstStat';
import PurchaseReturnReport from './Pharmacy/PurchaseReturnReport';
import VendorPayReport from './Pharmacy/VendorPayReport';
import DiReport from './Pharmacy/DiReport';
import ScheduleReport from './Pharmacy/ScheduleReport';
import DrugFlow from './Pharmacy/DrugFlow';
import PurchaseGstReport from './Pharmacy/PurchaseGstReport';
import PurchaseGstStat from './Pharmacy/PurchaseGstStat';
import PatientDrugFlow from './Pharmacy/PatientDrugFlow';
import ClosingStatement from './Pharmacy/ClosingStatement';
import AbcAnalysis from './Pharmacy/AbcAnalysis';
import DailyConsolidate from './Pharmacy/DailyConsolidate';
import PharmProfit from './Pharmacy/PharmProfit';
//Ticketing
import Ticketing from './Ticketing/Ticketing';
import TicketMenu from './Ticketing/TicketMenu';
import TicketResponse from './Ticketing/TicketResponse';
//BloodBank
import ReceiverRegister from './BloodBank/ReceiverRegister';
import DonorRegister from './BloodBank/DonorRegister';
import BloodMenu from './BloodBank/BloodMenu';
import DonationList from './BloodBank/DonationList';
import TransfusionList from './BloodBank/TransfusionList';
import BloodStock from './BloodBank/BloodStock';
//TeleMedicine
import RoomPage from "./Telemedicine/Room";
import ThreedImg from "./Consultant/Threedimg";
//CRM
import CrmMenu from './Crm/CrmMenu';
import LeadList from './Crm/LeadList';

// ==============================
// Import All Pack Pages
// ==============================
import PackMenu from './Package/PackMenu';
import AddPack from './Package/AddPack';
import EditPack from './Package/EditPack';
import EditPackInv from './Package/EditPackInv';
import EditPackLab from './Package/EditPackLab';
import EditPackMin from './Package/EditPackMin';
import EditPackPrice from './Package/EditPackPrice';
import EditPackRoom from './Package/EditPackRoom';
import EditPackSurgery from './Package/EditPackSurgery';

import IpPackPay from './Package/IpPackPay';
import OpPackPay from './Package/OpPackPay';
import PackEntry from './Package/PackEntry';
import PackEntryIp from './Package/PackEntryIp';
import PackInv from './Package/PackInv';
import PackInvoiceIp from './Package/PackInvoiceIp';
import PackInvoiceOp from './Package/PackInvoiceOp';
import PackLab from './Package/PackLab';
import PackMin from './Package/PackMin';
import PackPrice from './Package/PackPrice';
import PackRequest from './Package/PackRequest';
import PackRequestIp from './Package/PackRequestIp';
import PackRoom from './Package/PackRoom';
import PackSurgery from './Package/PackSurgery';
//Stores
import StoresMenu from './Stores/StoresMenu';
import EqpPoList from './Stores/EqpPoList';
import EqpPoInvoice from './Stores/EqpPoInvoice';
import EqpNewProduct from './Stores/EqpNewProduct';
import AddSupplier from './Stores/AddSupplier';
import EditSupplier from './Stores/EditSupplier';
import AddEqpCat from './Stores/AddEqpCat';
import EditEqpCat from './Stores/EditEqpCat';
import AddEqpSubCat from './Stores/AddEqpSubCat';
import EditEqpSubCat from './Stores/EditEqpSubCat';
import EqpRaiseIndent from './Stores/EqpRaiseIndent';
import EqpGrnEntry from './Stores/EqpGrnEntry';
import EqpGrnList from './Stores/EqpGrnList';
import EqpGrnInvoice from './Stores/EqpGrnInvoice';
import EqpPurchaseReturn from './Stores/EqpPurchaseReturn';
import EqpInvoiceReturn from './Stores/EqpInvoiceReturn';
import SupplierSearch from './Stores/SupplierSearch';
import SupplierPayment from './Stores/SupplierPayment';
import EquipList from './Stores/EquipList';
import EditEqp from './Stores/EditEqp';
import IndentEqpList from './Stores/IndentEqpList';
import EditIndentEqp from './Stores/EditIndentEqp';
import EqpInvoiceIndent from './Stores/EqpInvoiceIndent';
import IssueIndentEqp from './Stores/IssueIndentEqp';
import EqpReturnReport from './Stores/EqpReturnReport';
import EqpGstReport from './Stores/EqpGstReport';
import EqpGstStat from './Stores/EqpGstStat';
//Speech Text
import SpeechText from './Other/SpeechText';
import Events from './Other/Events';
import ToDo from './Other/ToDo';
import EditToDo from './Other/EditToDo';
import FloatingChatbot from './Other/FloatingChatbot';

import {AuthProvider} from '../context/AuthContext';
import PrivateRoute from './PrivateRoute';
import PatPrivateRoute from './PatPrivateRoute';
import { useState } from 'react';


function Main() {
  const location = useLocation();

  // Hide chatbot on login page
  const showChatbot = location.pathname !== "/user-login";
  return (
    <div className="App">
             <AuthProvider>
               <Header />
               <Routes>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Management']}/>}>
                        <Route path="/user-register" element={<Register />}  />
                        <Route path="/master-menu" element={<MasterMenu />} />
                        <Route path="/mis-menu" element={<MisMenu />} />
                         
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'FrontOffice' , 'Nurse']}/>}>
                        <Route path="/front-menu" element={<FrontMenu />} />
                        //Minor
                        <Route path="/add-minor-cat" element={<AddMinCat />} />
                        <Route path="/edit-minor-cat/:cat_id" element={<EditMinCat />} />
                        <Route path="/add-minor-comp" element={<AddMinComp />} />
                        <Route path="/edit-minor-comp/:comp_id" element={<EditMinComp />} />
                        <Route path="/fo-min-entry" element={<FoMinEntry />} />
                        //Patient
                        <Route path="/add-patient" element={<PatientRegister />} />
                        <Route path="/edit-patient/:patId" element={<EditPatient />} />

                        //Appointment
                        <Route path="/op-appointment/:dept_id" element={<OpDoc />} />
                        <Route path="/op-dep" element={<OpDep />} />
                        <Route path="/fix-appointment/:cons_id" element={<FixAppointment />} />
                        <Route path="/token-view/:appt_id" element={<OpToken />} />
                        <Route path="/op-dashboard" element={<OpDashboard />} />
                        <Route path="/vitals-view" element={<VitalsView />} />
                        <Route path="/op-vitals/:appt_id" element={<OpVitals />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Cashier', 'Accounting']}/>}>
                        <Route path="/account-menu" element={<AccountMenu />} />
                        //Accounting
                        <Route path="/add-bank" element={<AddBank />} />
                        <Route path="/add-deposit" element={<AddDeposit />} />
                        <Route path="/add-cheque" element={<AddCheque />} />
                        <Route path="/account-report" element={<AccountReport />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Cashier', 'Hr']}/>}>
                       <Route path="/hrms-menu" element={<HrmsMenu />} />
                       //Hrms
                        <Route path="/add-employee" element={<AddEmployee />} />
                        <Route path="/emp-list" element={<EmpList />} />
                        <Route path="/edit-emp/:id" element={<EditEmployee />} />
                        <Route path="/emp-view/:id/" element={<ViewEmployee />} />
                        <Route path="/generate-payslip/:id/" element={<GeneratePayslip />} />
                        <Route path="/salary-list" element={<SalaryList />} />
                        <Route path="/view-payslip/:emp_id/:id/" element={<ViewPayslip />} />
                        <Route path="/add-shift" element={<Shift />} />
                        <Route path="/shift-view/:id/" element={<EditShift />} />
                        <Route path="/emp-rooster" element={<EmpRooster />} />
                        <Route path="/emp-leave" element={<LeaveApplication />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Lab', 'LabAdmin', 'FrontOffice', 'Cashier', 'Radiology', 'Ip']}/>}>
                        <Route path="/alerts" element={<SystemAlerts />} />
                        <Route path="/cashier-lab" element={<CashLab />} />
                        <Route path="/cashier-inv" element={<CashInv />} />
                        <Route path="/lab-pay/:appt_id" element={<LabPayment />} />
                        <Route path="/ip-lab-pay/:appt_id" element={<IpLabPayment />} />
                        <Route path="/lab-invoice-op/:sale_lab/" element={<LabInvoiceOp />} />
                        <Route path="/cashier-pack" element={<CashPack />} />
	                <Route path="/accept-order-lab/:lab_id/" element={<CreateWO />} />
                        <Route path="/create-sample-id/:lab_id/:ltestid/" element={<CreateSampleid />} />
		    </Route>                    
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Cashier', 'Stores']}/>}>
                        <Route path="/stores-menu" element={<StoresMenu />} />
                        //Stores Masters
                        <Route path="/add-supplier" element={<AddSupplier />} />
                        <Route path="/edit-supplier/:id" element={<EditSupplier />} />
                        <Route path="/add-eqp-cat" element={<AddEqpCat />} />
                        <Route path="/edit-eqp-cat/:cat_id" element={<EditEqpCat />} />
                        <Route path="/add-eqp-subcat" element={<AddEqpSubCat />} />
                        <Route path="/edit-eqp-subcat/:subcat_id" element={<EditEqpSubCat />} />
                        <Route path="/equip-list" element={<EquipList />} />
                        <Route path="/indent-eqp-list" element={<IndentEqpList />} />

                        //Stores
                        <Route path="/eqp-po-list" element={<EqpPoList />} />
                        <Route path="/eqp-po-invoice/:grn_id/" element={<EqpPoInvoice />} />
                        <Route path="/add-eqp-product" element={<EqpNewProduct />} />
                        <Route path="/eqp-raise-indent" element={<EqpRaiseIndent />} />
                        <Route path="/eqp-invoice-indent/:sale_pharm/" element={<EqpInvoiceIndent />} />
                        <Route path="/eqp-grn-entry" element={<EqpGrnEntry />} />
                        <Route path="/eqp-grn-list" element={<EqpGrnList />} />
                        <Route path="/eqp-grn-invoice/:grn_id/" element={<EqpGrnInvoice />} />
                        <Route path="/eqp-purchase-return" element={<EqpPurchaseReturn />} />
                        <Route path="/eqp-invoice-return/:pur_return" element={<EqpInvoiceReturn />} />
                        <Route path="/supplier-search" element={<SupplierSearch />} />
                        <Route path="/supplier-payment/:supp_id/" element={<SupplierPayment />} />
                        <Route path="/edit-eqp/:id/" element={<EditEqp />} />
                        <Route path="/edit-indent-eqp/:id/" element={<EditIndentEqp />} />
                        <Route path="/issue-indent-eqp/:id/" element={<IssueIndentEqp />} />
                        <Route path="/eqp-return-report" element={<EqpReturnReport />} />
                        <Route path="/eqp-gst-report" element={<EqpGstReport />} />
                        <Route path="/eqp-gst-stat" element={<EqpGstStat />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Consultant', 'FrontOffice']}/>}>
                        <Route path="/telemedicine" element={<RoomPage />} />
                        <Route path="/threedimg/:appt_id/:con_id" element={<ThreedImg />} />

		                <Route path="/speechpre" element={<SpeechPre />} />
                    //Consultant
                        <Route path="/add-consultant" element={<AddConsultant />} />
                        <Route path="/edit-consultant/:cons_id" element={<EditConsultant />} />
                        <Route path="/consult-menu" element={<ConsultMenu />} />
                        <Route path="/add-ref-consultant" element={<AddRefConsultant />} />
                        <Route path="/add-cons-dept" element={<AddConsDept />} />
                        <Route path="/cons-view" element={<ConsView />} />
                        <Route path="/cons-detail/:appt_id" element={<ConsDetail />} />
                        <Route path="/op-case/:appt_id" element={<OpCaseSheet />} />
                        <Route path="/ip-view" element={<IpViewList />} />
                        <Route path="/ip-cons-detail/:ip_id" element={<IpConsDetail />} />
                        <Route path="/cons-search" element={<ConsSearch />} />

                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Cashier', 'FrontOffice', 'Ip', 'Nurse', 'Management']}/>}>
                        <Route path="/mis-collection" element={<MisCollection />} />
                        <Route path="/add-department" element={<AddDept />} />
                        <Route path="/add-designation" element={<AddDesignation />} />
                        <Route path="/barcode" element={<GenerateBarcode />} />

                        <Route path="/add-template" element={<AddTemplate />} />
                        <Route path="/edit-template/:id" element={<EditTemplate />} />

                        //Cashier
                        <Route path="/cash-menu" element={<CashMenu />} />
                        <Route path="/payment-detail" element={<PaymentDetail />} />
                        <Route path="/collection-all" element={<CollectionAll />} />
                        <Route path="/collection-credit" element={<CollectionCredit />} />
                        <Route path="/pending-bills" element={<PendingBills />} />
                        <Route path="/discount-report" element={<DiscountReport />} />
                        <Route path="/refund-entry" element={<RefundEntry />} />
                        <Route path="/refund-details/:pat_id" element={<RefundDetails />} />
                        <Route path="/cancel-entry" element={<CancelEntry />} />
                        <Route path="/cancel-details/:pat_id" element={<CancelBill />} />
                        <Route path="/refund-report" element={<RefundReport />} />
                        <Route path="/refund-invoice-op/:refund/" element={<RefundInvoiceOp />} />
                        <Route path="/due-entry" element={<DueEntry />} />
                        <Route path="/due-details/:pat_id" element={<DueDetails />} />
                        <Route path="/due-report" element={<DueReport />} />
                        <Route path="/due-invoice-op/:due/" element={<DueInvoiceOp />} />
                        <Route path="/add-expense" element={<AddExpense />} />
                        <Route path="/expense-report" element={<ExpenseReport />} />
                        <Route path="/cashier-op" element={<CashOp />} />
                        <Route path="/op-view" element={<OpView />} />
                        <Route path="/op-pay/:appt_id" element={<OpPayment />} />
                        <Route path="/op-invoice/:sale_op/" element={<OpInvoice />} />
                        <Route path="/collection-op" element={<CollectionOp />} />


                        <Route path="/inv-pay/:appt_id" element={<InvPayment />} />
                        <Route path="/inv-invoice-op/:sale_inv/" element={<InvInvoiceOp />} />
                        <Route path="/collection-inv" element={<CollectionInv />} />
                        <Route path="/cons-pay-report" element={<ConsPayReport />} />
                        <Route path="/cons-payment/:cons_id/" element={<ConsPayment />} />
                        <Route path="/ip-inv-pay/:appt_id" element={<IpInvPayment />} />

                        <Route path="/cashier-min" element={<CashMin />} />
                        <Route path="/min-entry/:pat_id" element={<MinEntry />} />
                        <Route path="/min-view" element={<MinView />} />
                        <Route path="/min-pay/:appt_id" element={<MinPayment />} />
                        <Route path="/min-invoice-op/:sale_min/" element={<MinInvoiceOp />} />
                        <Route path="/collection-min" element={<CollectionMin />} />

                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Lab', 'LabAdmin', 'FrontOffice']}/>}>
                        //Lab
                        <Route path="/lab-menu" element={<LabMenu />} />
                        <Route path="/add-cat" element={<AddCat />} />
                        <Route path="/edit-cat/:cat_id" element={<EditCat />} />
                        <Route path="/add-subcat" element={<AddSubCat />} />
                        <Route path="/edit-subcat/:subcat_id" element={<EditSubCat />} />
                        <Route path="/add-test" element={<AddTest />} />
                        <Route path="/view-test" element={<ViewTest />} />
                        <Route path="/edit-test/:test_id" element={<EditTest />} />
                        <Route path="/fo-lab-entry" element={<FoLabEntry />} />
                        <Route path="/lab-entry/:pat_id" element={<LabEntry />} />


                        <Route path="/lab-view" element={<LabView />} />
                        <Route path="/lab-result-view" element={<LabResultView />} />
                        <Route path="/lab-result-entry/:appt_id/:ltestid" element={<LabResultEntry />} />
                        <Route path="/lab-result-entry-saved/:appt_id/:ltestid" element={<LabResultEntrySaved />} />
                        <Route path="/lab-report-op/:id/" element={<LabReportOp />} />


                        <Route path="/fo-ip-lab-entry" element={<FoIpLabEntry />} />
			            <Route path="/lab-machine" element={<LabMachine />} />
                        <Route path="/order-accept" element={<OrderAccept />} />
                        <Route path="/sample-collect" element={<SampleCollect />} />

                        <Route path="/ip-lab-result-entry/:appt_id/:ltestid/:ip_id" element={<IpLabResultEntry />} />
                        <Route path="/ip-lab-result-entry-saved/:appt_id/:ltestid/:ip_id" element={<IpLabResultEntrySaved />} />
                        <Route path="/lab-report-ip/:id/" element={<LabReportIp />} />

                        <Route path="/lab-result-view-all" element={<LabAllResultView />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Radiology', 'FrontOffice', 'Cashier']}/>}>
                    //Radiology
                        <Route path="/inv-view" element={<InvView />} />
                        <Route path="/inv-menu" element={<InvMenu />} />
                        <Route path="/add-radio" element={<AddRadio />} />
                        <Route path="/edit-components/:components_id" element={<EditRadio />} />
                        <Route path="/fo-inv-entry" element={<FoInvEntry />} />
                        <Route path="/inv-entry/:pat_id" element={<InvEntry />} />
                        <Route path="/fo-ip-inv-entry" element={<FoIpInvEntry />} />
                        <Route path="/inv-result-enter/:appt_id/:itest_id" element={<InvResultEntry />} />
                        <Route path="/inv-files-view" element={<InvResultView />} />
                        <Route path="/inv-images/:id" element={<InvFilesView />} />
                        <Route path="/start-dicom" element={<DicomStart />} />
                        <Route path="/view-dicom" element={<DICOMViewer />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Pharmacy', 'Cashier', 'PharmacyStore']}/>}>
                        <Route path="/pharm-menu" element={<PharmMenu />} />
                        <Route path="/pharm-store" element={<PharmStore />} />
                    //Pharmacy
                        <Route path="/drug-view" element={<DrugView />} />
                        <Route path="/drug-pay-other/:pat_id" element={<DrugPayOther />} />

                        <Route path="/drug-pay-dr/:did" element={<DrugPayDr />} />
                        <Route path="/drug-pay-save/:did" element={<DrugPaySaved />} />
                        <Route path="/sales-return/:sale_pharm" element={<SalesReturn />} />
                        <Route path="/pharm-invoice-return/:sale_return/" element={<PharmInvoiceReturn />} />

                        <Route path="/grn-entry" element={<GrnEntry />} />
                        <Route path="/grn-list" element={<GrnList />} />
                        <Route path="/grn-invoice/:grn_id/" element={<GrnInvoice />} />
                        <Route path="/po-list" element={<PoList />} />
                        <Route path="/po-invoice/:grn_id/" element={<PoInvoice />} />
                        <Route path="/internal-return" element={<InternalReturn />} />
                        <Route path="/purchase-return" element={<PurchaseReturn />} />
                        <Route path="/purchase-return-invoice/:pur_return" element={<PurchaseInvoiceReturn />} />


                        <Route path="/vendor-search" element={<VendorSearch />} />
                        <Route path="/vendor-payment/:dist_id/" element={<VendorPayment />} />
                        //Pharmacy Masters
                        <Route path="/add-manufacturer" element={<AddManufacturer />} />
                        <Route path="/edit-manufacturer/:id" element={<EditManufacturer />} />
                        <Route path="/add-distributor" element={<AddDistributor />} />
                        <Route path="/edit-distributor/:id" element={<EditDistributor />} />
                        <Route path="/drug-list" element={<DrugList />} />
                        <Route path="/expiry-list" element={<ExpiryList />} />
                        <Route path="/indent-expiry-list" element={<IndentExpiryList />} />
                        <Route path="/indent-drug-list" element={<IndentDrugList />} />
                        <Route path="/edit-pharm/:id/" element={<EditDrug />} />
                        <Route path="/edit-generic/:id/" element={<EditGeneric />} />
                        <Route path="/edit-indent/:id/" element={<EditIndentDrug />} />
                        <Route path="/drug-generic" element={<AddDrugGeneric />} />
                        <Route path="/add-new-product" element={<AddNewProduct />} />
                        //Pharmacy Reports
                        <Route path="/pharm-collection-all" element={<PharmCollectionAll />} />
                        <Route path="/sale-return-report" element={<SaleReturnReport />} />
                        <Route path="/detail-sales" element={<PharmDetail />} />
                        <Route path="/sales-gst-report" element={<SalesGstReport />} />
                        <Route path="/detail-sales-gst-report" element={<DetailSalesGstReport />} />
                        <Route path="/sales-gst-stat" element={<SalesGstStat />} />
                        <Route path="/purchase-return-report" element={<PurchaseReturnReport />} />
                        <Route path="/vendor-pay-report" element={<VendorPayReport />} />
                        <Route path="/di-report" element={<DiReport />} />
                        <Route path="/schedule-report" element={<ScheduleReport />} />
                        <Route path="/drug-flow" element={<DrugFlow />} />
                        <Route path="/purchase-gst-report" element={<PurchaseGstReport />} />
                        <Route path="/purchase-gst-stat" element={<PurchaseGstStat />} />
                        <Route path="/pat-drug-flow" element={<PatientDrugFlow />} />
                        <Route path="/closing-statement" element={<ClosingStatement />} />
                        <Route path="/abc-analysis" element={<AbcAnalysis />} />
                        <Route path="/daily-consolidate" element={<DailyConsolidate />} />
                        <Route path="/pharm-profit" element={<PharmProfit />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Ip', 'Nurse', 'Consultant', 'Cashier', 'Pharmacy', 'PharmacyStore']}/>}>
                        <Route path="/pharm-invoice-other/:sale_pharm/" element={<PharmInvoiceOther />} />
                        <Route path="/ot-drug-list" element={<OtDrugList />} />
                        <Route path="/drug-pay-ot/:ip_id" element={<DrugPayOt />} />
                        <Route path="/drug-pay-ip/:ip_id" element={<DrugPayIp />} />
                        <Route path="/drug-ip-pay/:did" element={<DrugIpPay />} />
                        <Route path="/raise-indent" element={<RaiseIndent />} />
                        <Route path="/drug-pay-indent/:did" element={<DrugPayIndent />} />
                        <Route path="/pharm-invoice-indent/:sale_pharm/" element={<PharmInvoiceIndent />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Lab', 'LabAdmin', 'Consultant', 'Radiology', 'Ip', 'Nurse', 'FrontOffice', 'Cashier']}/>}>
                        <Route path="/lab-report-all/:appt_id/" element={<LabReportOpAll />} />
                        <Route path="/ip-lab-report-all/:appt_id/" element={<LabReportIpAll />} />
                        <Route path="/lab-invoice-ip/:sale_lab/" element={<LabInvoiceIp />} />
                        <Route path="/inv-invoice-ip/:sale_inv/" element={<InvInvoiceIp />} />
                        <Route path="/ip-lab-entry/:pat_id/:ip_id" element={<IpLabEntry />} />
                        <Route path="/ip-inv-entry/:pat_id/:ip_id" element={<IpInvEntry />} />
                        <Route path="/collection-lab" element={<CollectionLab />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Ip', 'Nurse', 'Consultant', 'FrontOffice', 'Cashier']}/>}>
                        <Route path="/ip-menu" element={<IpMenu />} />
                        <Route path="/nurse-menu" element={<NurseMenu />} />

                    //Ip
                        <Route path="/ip-admit" element={<IpAdmit />} />
                        <Route path="/ip-pat/:pat_id" element={<IpPatientRegister />} />
                        <Route path="/ip-pat-new" element={<IpPatientRegisterNew />} />
                        <Route path="/confirm-ip-admit/:ip_id" element={<ConfirmIpAdmit />} />
                        <Route path="/ip-list" element={<IpList />} />
                        <Route path="/ip-wait-list" element={<IpWaitingList />} />
                        <Route path="/ip-pat-view/:ip_id" element={<IpPatView />} />
                        <Route path="/ip-advance/:ip_id" element={<IpAdvance />} />
                        <Route path="/cashier-ip" element={<CashIp />} />
                        <Route path="/ip-pay/:ip_id/:id/" element={<IpPayment />} />
                        <Route path="/ip-invoice/:sale_ip/" element={<IpInvoice />} />
                        <Route path="/refund-invoice-ip/:refund/" element={<RefundInvoiceIp />} />
                        <Route path="/ward-change/:ip_id/" element={<WardChange />} />
                        <Route path="/bill-list" element={<IpBillList />} />
                        <Route path="/bill-provisional/:ip_id/" element={<IpBillProv />} />
                        <Route path="/bill-summary/:ip_id/" element={<IpBillSummary />} />
                        <Route path="/bill-insurance/:ip_id/" element={<IpBillIns />} />
                        <Route path="/discharge-list-date" element={<DischargeDate />} />
                        <Route path="/discharge-notes/:ip_id/" element={<DischargeNotes />} />
                        <Route path="/edit-discharge/:id/" element={<EditDischarge />} />
                        <Route path="/discharge-summary/:ip_id/" element={<IpDischargeSummary />} />
                        <Route path="/preauth-list/" element={<PreAuthList />} />
                        <Route path="/payment-detail-ip" element={<PaymentDetailIp />} />
                        <Route path="/admit-list-date" element={<AdmitDate />} />
                        <Route path="/ip-refund-report" element={<IpRefundReport />} />
                        //Nurse
                        <Route path="/nurse-view-list" element={<NurseViewList />} />
                        <Route path="/nurse-pat-view/:ip_id" element={<NursePatView />} />
                        <Route path="/nurse-notes/:ip_id" element={<NurseNotes />} />
                        <Route path="/vital-sign/:ip_id" element={<VitalSign />} />
                        <Route path="/diet-detail/:ip_id" element={<DietDetail />} />
                        <Route path="/consult-notes/:ip_id" element={<ConsultNotes />} />
                        <Route path="/coma-scale/:ip_id" element={<ComaScale />} />
                        <Route path="/insulin/:ip_id" element={<Insulin />} />
                        <Route path="/respirate/:ip_id" element={<Respirate />} />
                        <Route path="/chest-physio/:ip_id" element={<ChestPhysio />} />
                        <Route path="/fluid/:ip_id" element={<Fluid />} />
                        <Route path="/positioning/:ip_id" element={<Positioning />} />
                        <Route path="/pupils/:ip_id" element={<Pupils />} />
                        <Route path="/ip-drug-entry/:pat_id/:ip_id" element={<IpDrugEntry />} />
                        <Route path="/ip-drug-use/:pat_id/:ip_id" element={<IpDrugUse />} />
                        //Insurance
                        <Route path="/insur-type" element={<AddInsurType />} />
                        <Route path="/insur-cmpy" element={<AddInsurCmpy />} />
                        <Route path="/edit-insur-cmpy/:id" element={<EditInsurCmpy />} />
                        <Route path="/insur-report" element={<InsuranceReport />} />
                        //Rooms
                        <Route path="/room-type" element={<AddRoom />} />
                        <Route path="/room-no" element={<AddRoomNo />} />
                        <Route path="/edit-room-no/:id" element={<EditRoomNo />} />
                        <Route path="/view-room" element={<ViewRoom />} />
                        //OT
                        <Route path="/ot-menu" element={<OtMenu />} />
                        <Route path="/surgery-type" element={<SurgeryType />} />
                        <Route path="/edit-surgery-type/:id" element={<EditSurgeryType />} />
                        <Route path="/ot-entry" element={<OtEntry />} />
                        <Route path="/ot-request/:ip_id" element={<OtRequest />} />
                        <Route path="/ot-list" element={<OtList />} />
                        <Route path="/ot-update/:id" element={<OtUpdate />} />
                        <Route path="/ot-notes-list" element={<OtNotesList />} />
                        <Route path="/ot-notes/:id" element={<OtNotes />} />
                        <Route path="/ot-report" element={<OtReport />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'BloodBank']}/>}>
                        //BloodBank
                        <Route path="/blood-bank" element={<BloodMenu />} />
                        <Route path="/add-donor" element={<DonorRegister />} />
                        <Route path="/add-receiver" element={<ReceiverRegister />} />
                        <Route path="/donation-list" element={<DonationList />} />
                        <Route path="/transfer-list" element={<TransfusionList />} />
                        <Route path="/blood-stock" element={<BloodStock />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Crm']}/>}>
				//Crm
                        <Route path="/crm-menu" element={<CrmMenu />} />
                        <Route path="/lead-list" element={<LeadList />} />
                        <Route path="/pack-menu" element={<PackMenu />} />
                        <Route path="/add-pack" element={<AddPack />} />
                        <Route path="/edit-pack/:id" element={<EditPack />} />
                        <Route path="/edit-packinv/:inv_id" element={<EditPackInv />} />
                        <Route path="/edit-packlab/:lab_id" element={<EditPackLab />} />
                        <Route path="/edit-packmin/:min_id" element={<EditPackMin />} />
                        <Route path="/edit-packprice/:id" element={<EditPackPrice />} />
                        <Route path="/edit-packroom/:room_id" element={<EditPackRoom />} />
                        <Route path="/edit-packsurgery/:surgery_id" element={<EditPackSurgery />} />

                        <Route path="/ip-pack-pay/:packid" element={<IpPackPay />} />
                        <Route path="/op-pack-pay/:packid" element={<OpPackPay />} />
                        <Route path="/pack-entry/:pat_id" element={<PackEntry />} />
                        <Route path="/pack-entry-ip/:ip_id" element={<PackEntryIp />} />
                        <Route path="/pack-inv" element={<PackInv />} />
                        <Route path="/pack-invoice-ip/:sale_ippack/" element={<PackInvoiceIp />} />
                        <Route path="/pack-invoice-op/:sale_oppack/" element={<PackInvoiceOp />} />
                        <Route path="/pack-lab" element={<PackLab />} />
                        <Route path="/pack-min" element={<PackMin />} />
                        <Route path="/pack-price" element={<PackPrice />} />
                        <Route path="/pack-request" element={<PackRequest />} />
                        <Route path="/pack-request-ip" element={<PackRequestIp />} />
                        <Route path="/pack-room" element={<PackRoom />} />
                        <Route path="/pack-surgery" element={<PackSurgery />} />
                    </Route>

                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Lab', 'LabAdmin', 'Radiology', 'Cashier', 'Consultant',
                        'Hr', 'Accounting', 'FrontOffice', 'Ip', 'Nurse', 'Pharmacy', 'PharmacyStore', 'Stores', 'Management', 'BloodBank', 'Crm']}/>}>
                        <Route path="/" element={<Home />}  exact />
                        <Route path="/support" element={<Support />} />
                        <Route path="/change-password" element={<ChangePassword />}  />
                        <Route path="/admin-menu" element={<Menu />} />
                        <Route path="/pat-search" element={<PatSearch />} />
                        <Route path="/pat-bill-search" element={<PatBillSearch />} />
                        <Route path="/bill-details/:pat_id" element={<PatBillDetails />} />
                        <Route path="/emr-details/:pat_id" element={<EmrDetails />} />
                        <Route path="/pat-print/:pat_id" element={<PatPrint />} />
                        <Route path="/ip-pat-print/:ip_id" element={<IpPatPrint />} />
                        <Route path="/news" element={<News />} />
                        <Route path="/comp-mess" element={<ComposeMessage />} />
                        //Ticketing
                        <Route path="/ticket-menu" element={<TicketMenu />} />
                        <Route path="/ticketing" element={<Ticketing />} />
                        <Route path="/ticket-response" element={<TicketResponse />} />
                        <Route path="/speech" element={<SpeechText />} />
                        <Route path="/events" element={<Events />} />
                        <Route path="/todolist" element={<ToDo />} />
                        <Route path="/edit-todolist/:id" element={<EditToDo />} />
                    </Route>

                    <Route path="/user-login" element={<Login />} />
               </Routes>
                 {showChatbot && <FloatingChatbot />}
             </AuthProvider>
             <Routes>
                <Route element={<PatPrivateRoute allowedRoles={['Patient']}/>}>
                  <Route path="/pat-menu" element={<PatMenu />} />
                  <Route path="/pat-emr-details/:pat_id" element={<PatEmrDetails />} />
                  <Route path="/pat-bill-details/:pat_id" element={<BillDetailsPat />} />
                  <Route path="/pat-lab-details/:pat_id" element={<PatLabDetails />} />
                  <Route path="/pat-vital-details/:pat_id" element={<PatVitalDetails />} />
                  <Route path="/pat-drug-details/:pat_id" element={<PatDrugDetails />} />
                  <Route path="/pat-op-case/:pat_id/:appt_id" element={<PatOpCaseSheet />} />
                  <Route path="/pat-lab-report-all/:appt_id" element={<PatLabReportOpAll />} />
                  <Route path="/pat-discharge-summary/:ip_id/" element={<PatDischargeSummary />} />
                  <Route path="/pat-bill-summary/:ip_id/" element={<PatIpBillSummary />} />
                  <Route path="/pat-drug-pres/:pat_id/:appt_id" element={<PatDrugPres />} />
                </Route>
                <Route path="/patient-login" element={<PatLogin />} />
             </Routes>
             <Footer />

    </div>
  );
}
export default Main;
